  // React
  import { useState } from 'react';
  import { useNavigate } from 'react-router-dom';

  // Redux
  import { fetchAllJobs } from '../redux/jobs/jobSlice';
  import { signInEmailAndPassword, resendVerificationEmail } from '../redux/auth/userSlice';
  import { getUserProfile } from '../redux/profiles/profileSlice';
  // Firebase
  import { auth } from '../firebase/firebase';

  // Error
  import { errorHandlingForLogin } from '../error/authErrorHandling';

  export const useLogin = (dispatch, onSuccess = null) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [usermail, setUsermail] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    const [randNumber, setRandNumber] = useState(0);
    const [loginError, setLoginError] = useState("");
    const [isEmailNotVerified, setIsEmailNotVerified] = useState(false);
    const [isLoading,setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
      
      e?.preventDefault();
      if (!usermail || !password) return;

      setIsEmailNotVerified(false);
      setIsLoading(true);
      try {
        const response = await dispatch(signInEmailAndPassword({
          email: usermail,
          password,
          remember
        }));

        if (signInEmailAndPassword.rejected.match(response)) {
          const errKey = errorHandlingForLogin(response.payload || '');
          setLoginError(errKey);
          if ((response.payload || '').includes('email-not-verified')) {
            setIsEmailNotVerified(true);
          }
          return;
        }

        // Successful login
        setShowLoginModal(false);
        setUsermail('');
        setPassword('');
        setRemember(false);
        if (onSuccess) onSuccess();
        else navigate('/');
      } catch (err) {
        console.error(err);
        setLoginError('Something went wrong');
      } finally {
        setIsLoading(false); // always reset loading
      }
    };

    const handleResendVerification = async () => {
      if (!usermail || !password) return;
      setIsLoading(true);
      try {
        const response = await dispatch(resendVerificationEmail({ email: usermail, password }));
        if (resendVerificationEmail.rejected.match(response)) {
          setLoginError('auth-errors.loginError.other-login');
        } else {
          setLoginError('');
          setIsEmailNotVerified(false);
          navigate('/verify-email', { state: { email: usermail, resent: true } });
        }
      } finally {
        setIsLoading(false);
      }
    };

    return {
      showLoginModal,
      setShowLoginModal,
      usermail,
      setUsermail,
      password,
      setPassword,
      remember,
      setRemember,
      randNumber,
      setRandNumber,
      handleSubmit,
      loginError,
      setLoginError,
      isLoading,
      setIsLoading,
      isEmailNotVerified,
      handleResendVerification,
    };
  };

  // Example Usage:

  // import React from 'react';
  // import useLogin from './useLogin';
  // 
  // function LoginPage() {
  //   const {
  //     showLoginModal,
  //     setShowLoginModal,
  //     usermail,
  //     setUsermail,
  //     password,
  //     setPassword,
  //     remember,
  //     setRemember,
  //     randNumber,
  //     setRandNumber,
  //     handleSubmit,
  //     loginError,
  //     setLoginError,
  //     isLoading,
  //     setIsLoading
  //   } = useLogin();
  // 
  //   const handleEmailChange = (event) => {
  //     setUsermail(event.target.value);
  //   };
  // 
  //   const handlePasswordChange = (event) => {
  //     setPassword(event.target.value);
  //   };
  // 
  //   const handleRememberChange = (event) => {
  //     setRemember(event.target.checked);
  //   };
  // 
  //   const handleFormSubmit = (event) => {
  //     event.preventDefault();
  //     handleSubmit();
  //   };
  // 
  //   return (
  //     <form onSubmit={handleFormSubmit}>
  //       <input type="email" value={usermail} onChange={handleEmailChange} />
  //       <input type="password" value={password} onChange={handlePasswordChange} />
  //       <label>
  //         Remember me
  //         <input type="checkbox" checked={remember} onChange={handleRememberChange} />
  //       </label>
  //       <button type="submit">Login</button>
  //     </form>
  //   );
  // }
  // 
  // export default LoginPage;
